import { httpClient } from "@/services";
import options from "@/store/modules/statistics/dispatchStatistics/options";
import getChartData from "@/store/modules/statistics/dispatchStatistics/getChartData";
import getGraph from "@/store/modules/statistics/dispatchStatistics/getGraph";
import { formatCurrency } from "@/helper";
import getDefaultDate from "@/helper/getDefaultDate";
import getUniqId from "@/helper/getUniqId";
import requestKeys from "@/constants/requestKeys";
import dispatchStatisticsHeader from "@/pages/Statistics/DispatchStatistics/dispatchStatisticsHeader";
import { downloadDoc } from "@/helper/getDownloadDoc";

export default {
	state: {
		dispatchFilter: null,
		dispatchGraph: { labels: [], amount: [], mileage: [] },
		dispatchGraphOptions: options,
		dispatchGraphData: null,
		dispatchGraphDispatch: null,
		dispatchList: null,
		dispatchTotal: null,
		dispatchSpotRate: null,
		dispatchData: null,
		dispatchRate: null,
		dispatchOrder: null,
		dispatchSort: null,
		dispatchLimit: null,
		disType: 'Delivery',
		disDate: getDefaultDate(),
		disWeeks: '4',
		isChangeData: null,
		isRefreshData: null,
		dispatchCustomers: null
	},
	mutations: {
		updateDispatchStatistics(state, { amount, graph, graphDispatch, total_load, total_truck }) {
			state.dispatchGraph = graph;
			state.dispatchGraphDispatch = graphDispatch;
			state.dispatchTotalLoad = total_load;

			state.dispatchData = {
				dispatchTotalLoad: total_load,
				dispatchAmount: formatCurrency(amount, 1, 'ru'),
				dispatchTotalTruck: total_truck
			};

			console.log('%c [  graph  ] ', 'color:#bada55', typeof graph, graph );
			state.dispatchGraph = getGraph(graph);
			console.log('%c [  state.dispatchGraph  ] ', 'color:#bada55', typeof state.dispatchGraph, state.dispatchGraph );
			state.dispatchGraphData = getChartData(state.dispatchGraph);
			console.log('%c [  state.dispatchGraphData  ] ', 'color:#bada55', typeof state.dispatchGraphData, state.dispatchGraphData );
		},
		updateStatisticsRate(state, { spot_rate, rateAverage }) {
			state.dispatchRate = rateAverage;
			state.dispatchSpotRate = spot_rate;
		},
		updateStatisticsFilter(state, payload) {
			state.dispatchFilter = payload;
		},
		updateStatisticsList(state, { total, rows, sort, order, limit }) {
			state.dispatchTotal = total;
			state.dispatchList = rows;
			state.dispatchSort = sort;
			state.dispatchOrder = order;
			state.dispatchLimit = limit ?? 15;
		},
		updateDataChange(state, { weeks, type, date }) {
			if (weeks) state.disWeeks = weeks;
			if (type) state.disType = type;
			if (date) state.disDate = date;
			state.isChangeData = getUniqId();
		},
		updateResetData(state) {
			state.disType = 'Delivery';
			state.disDate = getDefaultDate();
			state.disWeeks = '4';
			state.isRefreshData = getUniqId();
		},
		updateDispatchStatisticsReports(state, { customers }) {
			state.dispatchCustomers = customers;
		},
		updateDispatchExport(state, payload) {
			downloadDoc(payload);
		}
	},
	actions: {
		async getStatisticsList({ commit, state }, values) {
			if (values) {
				const { disType, disDate, disWeeks } = state;

				values.datePeriod = { type: disType, date: disDate };
				values.weeks = disWeeks;
			}

			try {
				const { data } = await httpClient.post('statistics/list', values);
				if (data) {
					commit('updateStatisticsList', data);
					commit('updateSettings', { settings: data.settings, key: requestKeys.STATISTICS, defaultHeader: dispatchStatisticsHeader });
				}
			} catch (e) {
				console.error(e);
			}
		},
		async getStatisticsFilter({ commit, state }, values) {
			if (values) {
				const { disType, disDate, disWeeks } = state;

				values.datePeriod = { type: disType, date: disDate };
				values.weeks = disWeeks;
			}

			try {
				const { data } = await httpClient.post('statistics/filter', values);
				if (data) {
					commit('updateStatisticsFilter', data);
				}
			} catch (e) {
				console.error(e);
			}
		},
		async getStatisticsRate({ commit }) {
			try {
				const { data } = await httpClient.post('statistics/rate-average');
				if (data) {
					commit('updateStatisticsRate', data);
				}
			} catch (e) {
				console.error(e);
			}
		},
		async getDispatchStatistics({ commit, state }, values) {
			if (values) {
				const { disType, disDate, disWeeks } = state;

				values.datePeriod = { type: disType, date: disDate };
				values.weeks = disWeeks;
			}

			try {
				const { data } = await httpClient.post('/graph', values);
				if (data) {
					commit('updateDispatchStatistics', data);
				}
			} catch (error) {
				console.error(error);
			}
		},
		onDataChange({ commit }, values) {
			commit('updateDataChange', values);
		},
		async onDispatchStatisticsExport({ commit, state, dispatch }, values) {
			dispatch("actionPreloader", true);
			let url = '/trips/files';
			if (values) {
				const { disWeeks } = state;

				// values.datePeriod = { type: disType, date: disDate };
				values.weeks = disWeeks;
				values.order = null;
				values.type = 'graph';

				if (values.fileType === 4) url = '/loads/export';
				if (values.fileType === 5) url = '/trips/export';
				if (values.fileType === 0) delete values.fileType;
			}

			try {
				const { data } = await httpClient.post(url, values);
				if (data) {
					commit('updateDispatchExport', data);
				}

				dispatch("actionPreloader", false);
			} catch (e) {
				console.error(e);
			}
		},
		async getDispatchStatisticsReports({ commit, dispatch, state }, values) {
			if (values) {
				const { disType, disDate, disWeeks } = state;

				values.datePeriod = { type: disType, date: disDate };
				values.weeks = disWeeks;
				values.order = null;
			}

			try {
				const { data } = await httpClient.post('/reports/create', values);
				if (data) {
					commit('updateDispatchStatisticsReports', data);
				}
				dispatch("actionPreloader", false);
			} catch (e) {
				console.error(e);
			}

			commit('updateReportPending', false);
		},
		async onSendReports({ commit }, values) {
			try {
				return await httpClient.post('/reports', values);
			} catch (e) {
				console.error(e);
			}

			commit('updateReportPending', false);
		},
		onResetData({ commit }) {
			commit('updateResetData');
		},

	},
	getters: {
		dispatchFilter: s => s.dispatchFilter,
		dispatchGraph: s => s.dispatchGraph,
		dispatchGraphDispatch: s => s.dispatchGraphDispatch,
		dispatchList: s => s.dispatchList,
		dispatchTotal: s => s.dispatchTotal,
		dispatchSpotRate: s => s.dispatchSpotRate,
		dispatchData: s => s.dispatchData,
		dispatchGraphOptions: s => s.dispatchGraphOptions,
		dispatchGraphData: s => s.dispatchGraphData,
		dispatchSort: s => s.dispatchSort,
		dispatchOrder: s => s.dispatchOrder,
		dispatchLimit: s => s.dispatchLimit,
		dispatchRate: s => s.dispatchRate,
		disType: s => s.disType,
		disDate: s => s.disDate,
		disWeeks: s => s.disWeeks,
		isChangeData: s => s.isChangeData,
		isRefreshData: s => s.isRefreshData,
		dispatchCustomers: s => s.dispatchCustomers,
	}
};
